import { betterFetch as defaultFetch } from '@e-socna/better-fetch';
import type { BetterFetch } from '@e-socna/better-fetch';

import { geoplRetryStrategy } from './strategies/retry.strategy';
import type { GEOPL_RATE_LIMITS } from './constants/rate-limits.constant';

/**
 * Create a configured fetcher for geopl API with automatic retry handling
 *
 * @param serviceType - Type of geopl service (elevation, routing, geocoding, etc.)
 * @param fetch - Optional custom fetch implementation (defaults to betterFetch)
 * @returns A configured fetch function with retry strategy
 *
 * @example
 * ```typescript
 * import { createGeoplFetcher } from '@e-socna/gis';
 *
 * const geoplFetch = createGeoplFetcher('elevation');
 * const data = await geoplFetch<AltiCodingResult>(url);
 * ```
 */
export const createGeoplFetcher =
  (
    serviceType: keyof typeof GEOPL_RATE_LIMITS,
    fetch: BetterFetch = defaultFetch,
  ) =>
  <T>(url: string, options?: RequestInit) =>
    fetch<T>(url, options ?? {}, {
      retryStrategy: geoplRetryStrategy(serviceType),
      retries: 5,
    });
